import moment from "moment";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec"
];

export const convertChartDate = dates => {
  let newDate = [];
  let newCount = [];

  dates.forEach(({ date, count }) => {
    let newdate = new Date(date);
    let month = months[newdate.getMonth()];

    newDate.push(newdate.getDate() + " " + month);
    newCount.push(count);
  });

  return { newDate, newCount };
};

export const getRealTimeDiff = time => {
  let now = moment();
  let createdTime = moment.utc(time).toDate();

  let dayDiff = Math.floor(moment.duration(now.diff(createdTime)).asDays());
  let day = addSuffix(dayDiff, "day");
  if (day) {
    return day;
  }

  let hourDiff = Math.floor(
    moment.duration(now.diff(createdTime)).asHours() % 60
  );
  let hour = addSuffix(hourDiff, "hour");
  if (hour) {
    return hour;
  }

  let minDiff = Math.floor(
    moment.duration(now.diff(createdTime)).asMinutes() % 60
  );
  let min = addSuffix(minDiff, "min");
  if (min) {
    return min;
  }

  let secDiff = Math.floor(
    moment.duration(now.diff(createdTime)).asSeconds() % 60
  );
  let sec = addSuffix(secDiff, "sec");
  if (sec) {
    return sec;
  }

  return "just now";
};

const addSuffix = (time, str) => {
  if (time > 0) {
    if (time > 1) {
      str += "s";
    }
    return time + " " + str + " ago";
  }

  return "";
};



// WEBPACK FOOTER //
// ./src/js/date.js